/**
 * Typy zpráv, které ServiceWorker příjmá
 */
export enum ServiceWorkerMessageType {
    /** Informace o aktivnosti klientské stránky */
    alive = "alive",
    /** Informace o změně jazyka klientské stránky */
    languageChanged = "languageChanged",
    /** Žádost o oživení session uživatele */
    renewSession = "renewSession",
    /** Informace o novém CSRF tokenu */
    updateAuthId = "updateAuthId",
    /** Žádost a kontrolu dostupných aktualizací a aktualizace nastavení */
    updateData = "updateData",
    /** Žádost o diagnostická data. Používáno automatickými testy. */
    performance = "performance",
    /** Nastavení limitu pro timing buffer. Používáno automatickými testy. */
    setResourceTimingBuffer = "setResourceTimingBuffer",
}

interface IServiceWorkerMessageEmpty<TMessageType extends keyof MessageTypeToPayloadMap> {
    /** Typ zprávy */
    readonly type: TMessageType;
}

interface IServiceWorkerMessage<TMessageType extends keyof MessageTypeToPayloadMap> extends IServiceWorkerMessageEmpty<TMessageType> {
    /** Data zprávy */
	readonly payload: MessageTypeToPayloadMap[TMessageType];
}

type MessageTypeToPayloadMap = {
    [ServiceWorkerMessageType.alive]: void;
    [ServiceWorkerMessageType.languageChanged]: { readonly language: string };
    [ServiceWorkerMessageType.renewSession]: void;
    [ServiceWorkerMessageType.updateAuthId]: { readonly authId: string };
    [ServiceWorkerMessageType.updateData]: void;
    [ServiceWorkerMessageType.performance]: void;
    [ServiceWorkerMessageType.setResourceTimingBuffer]: {readonly bufferSize: number};
};

/** Všechny zprávy, které lze ServiceWorkeru poslat */
export type ServiceWorkerMessage =
    IServiceWorkerMessageEmpty<ServiceWorkerMessageType.alive> |
    IServiceWorkerMessage<ServiceWorkerMessageType.languageChanged> |
    IServiceWorkerMessageEmpty<ServiceWorkerMessageType.renewSession> |
    IServiceWorkerMessage<ServiceWorkerMessageType.updateAuthId> |
    IServiceWorkerMessageEmpty<ServiceWorkerMessageType.updateData> |
    IServiceWorkerMessageEmpty<ServiceWorkerMessageType.performance> |
    IServiceWorkerMessage<ServiceWorkerMessageType.setResourceTimingBuffer>;
